import { MobileDeliveryProposalFormTable } from "@/widgets/delivery-proposal-form-table/mobile-delivery-proposal-form-table";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DeliveryProposalFormLayout } from "../../../../../widgets/delivery-proposal-form-layout";
import { DeliveryProposalFormTable } from "../../../../../widgets/delivery-proposal-form-table";
import type { AdminDeliveryProposalDetailPageProps } from "../../../model";

export const MemoForm = (props: {
  draftOfferCargo: AdminDeliveryProposalDetailPageProps["draftOfferCargo"];
  previewValues: NonNullable<
    AdminDeliveryProposalDetailPageProps["previewValues"]
  >;
}) => {
  const { t } = useTranslation();
  const { draftOfferCargo, previewValues } = props;

  const memoCells = [draftOfferCargo.data?.memo, previewValues.memo];

  return (
    <DeliveryProposalFormLayout
      title={t("offerCargo.desitination.memo")}
      isLoading={false}
    >
      <div>
        {/* PC用のフォーム */}
        <Box display={{ xs: "none", sm: "block" }}>
          <DeliveryProposalFormTable
            headers={["荷物", "提案"]}
            rows={[
              {
                title: t("offerCargo.desitination.memo"),
                cells: memoCells,
              },
            ]}
          />
        </Box>

        {/* モバイル用のフォーム */}
        <Box display={{ xs: "block", sm: "none" }}>
          <MobileDeliveryProposalFormTable
            items={[
              {
                label: t("offerCargo.desitination.memo"),
                cargo: memoCells[0],
                proposal: memoCells[1],
              },
            ]}
          />
        </Box>
      </div>
    </DeliveryProposalFormLayout>
  );
};
